import { render, staticRenderFns } from "./DoorFamilyList.vue?vue&type=template&id=32b744d4&"
import script from "./DoorFamilyList.vue?vue&type=script&lang=ts&"
export * from "./DoorFamilyList.vue?vue&type=script&lang=ts&"
import style0 from "./DoorFamilyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports